// extracted by mini-css-extract-plugin
export default {"searchInput":"Search_searchInput__neJhv"};